import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { brandStore } from '@/stores';

export const BrandScopeRoute = observer(() => {
  const params = useParams<{ brandId: string }>();
  const brandId = params.brandId?.trim() ?? '';

  useEffect(() => {
    if (!brandStore.initialized && !brandStore.loading) {
      void brandStore.fetchBrands().catch(() => undefined);
    }
  }, []);

  const targetBrand = brandStore.getBrandById(brandId);

  useEffect(() => {
    if (!targetBrand) {
      return;
    }

    if (brandStore.activeBrandId !== targetBrand.id) {
      brandStore.setActiveBrand(targetBrand.id);
    }
  }, [targetBrand]);

  const handleRetry = () => {
    if (brandStore.loading) {
      return;
    }

    void brandStore.fetchBrands().catch(() => undefined);
  };

  if (!targetBrand && (brandStore.loading || !brandStore.initialized)) {
    return (
      <div className="min-h-screen bg-gray-50/50 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-primary border-r-transparent"></div>
          <p className="mt-4 text-sm text-muted-foreground">加载 Brand 中...</p>
        </div>
      </div>
    );
  }

  if (!targetBrand && brandStore.error) {
    return (
      <div className="min-h-screen bg-gray-50/50 flex items-center justify-center px-6">
        <div className="w-full max-w-md rounded-lg border border-border bg-background p-6 text-center shadow-sm">
          <h1 className="text-base font-semibold text-foreground">
            加载 Brand 失败
          </h1>
          <p className="mt-2 text-sm text-muted-foreground">
            {brandStore.error}
          </p>
          <Button
            className="mt-5"
            onClick={handleRetry}
            loading={brandStore.loading}
          >
            重试
          </Button>
        </div>
      </div>
    );
  }

  if (!targetBrand) {
    return <Navigate to="/brand-selection" replace />;
  }

  return <Outlet />;
});
